import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppStateService, WishlistItem } from '../../services/app-state.service';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html'
})
export class WishlistComponent implements OnInit, OnDestroy {
  wishlistItems: WishlistItem[] = [];
  loaded = false;
  private sub = new Subscription();

  constructor(public state: AppStateService, public router: Router) {}

  ngOnInit() {
    this.sub.add(this.state.wishlistItems$.subscribe(items => this.wishlistItems = items));
    this.sub.add(this.state.wishlistLoaded$.subscribe(v => this.loaded = v));
    // Make sure the saved wishlist is (re)loaded when landing directly here.
    if (!this.state.wishlistLoaded$.value) this.state.loadWishlistFromApi();
  }

  ngOnDestroy() { this.sub.unsubscribe(); }

  removeFromWishlist(id: string) { this.state.toggleWishlist(id); }

  navigateToPDP(wp: WishlistItem) {
    const type = (wp.wallpaper_type || '').toLowerCase();
    const slug = wp.slug || wp.id;

    if (type === 'featured') {
      // Wall art / featured frame items — use /featured-art route (slug = on_sale title_slug)
      this.router.navigate(['/featured-art', slug]);
      return;
    }
    if (type.includes('collage')) {
      // collage_slug is preferred; wp.slug may contain it after moveToWishlist fix.
      // If slug is purely numeric (old saved items), try localStorage collage_prices.
      let collageSlug = wp.slug || '';
      if (!collageSlug || /^\d+$/.test(collageSlug)) {
        try {
          const stored = JSON.parse(localStorage.getItem('collage_prices') || '{}');
          collageSlug = stored[wp.id]?.slug || stored[collageSlug]?.slug || '';
        } catch {}
      }
      this.router.navigate(['/collage-set', collageSlug || wp.id]);
      return;
    }
    // Product-customization items (frames, prints, canvas) saved from cart
    if (wp.product_slug) {
      this.router.navigate(['/product-customization'], {
        queryParams: { product: wp.product_slug, product_type: wp.product_type_slug || 'framing' }
      });
      return;
    }
    // Fallback: detect by wallpaper_type label for older wishlist items without product_slug
    const ptByType: Record<string, string> = {
      'photo frame': 'framing',   'photo-frame': 'framing',
      'frame only':  'frame_only', 'frame-only':  'frame_only',
      'only print':  'print_only', 'only-print':  'print_only',
      'canvas':      'canvas',
    };
    if (ptByType[type]) {
      this.router.navigate(['/product-customization'], {
        queryParams: { product: 'frame_your_photos', product_type: ptByType[type] }
      });
      return;
    }
    if (wp.collection_slug && wp.slug) {
      this.router.navigateByUrl(`/wallpaper/${wp.collection_slug}/${wp.slug}/0-0`);
    } else {
      this.router.navigate(['/pdp', slug]);
    }
  }

  navigateToListing() { this.router.navigate(['/listing']); }
}
